import { BREAKPOINTS } from '@constants/common'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { GuestsVoice } from '@type/buzzkuri/programs-categor'
import React, { useContext } from 'react'
import { GuestsVoicesContentItemDescription } from './Description'
import { GuestsVoicesContentItemGuestInformation } from './GuestInformation'
import { GuestsVoicesContentItemImage } from './Image'

type Props = {
  guestsVoice: GuestsVoice
}

export const GuestsVoicesContentItem = ({
  guestsVoice,
}: Props): JSX.Element => {
  const winSize = useContext(WindowSizeContext)
  return winSize?.width > BREAKPOINTS.laptop ? (
    <div className="flex flex-row justify-between items-center">
      <GuestsVoicesContentItemImage />

      <div className="flex flex-col justify-between lg:w-[46.8vw]">
        <GuestsVoicesContentItemDescription
          description={guestsVoice.description}
        />
        <div className="flex justify-end">
          <GuestsVoicesContentItemGuestInformation
            guestInformation={guestsVoice.guestInformation}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <div className="ml-[3.7vw]">
          <GuestsVoicesContentItemImage />
        </div>
        <div className="flex justify-end items-end mr-[3.2vw] ml-[7.7vw] w-full">
          <GuestsVoicesContentItemGuestInformation
            guestInformation={guestsVoice.guestInformation}
          />
        </div>
      </div>
      <div className="mt-[8.1vw]">
        <GuestsVoicesContentItemDescription
          description={guestsVoice.description}
        />
      </div>
    </div>
  )
}
